import type { AtomicTask, Task } from "@shared/domain";

export interface ParsedTaskDetails {
  summary?: string;
  definitionOfDone?: string;
}

export const taskProgress = (task: Task, atomicTasks: AtomicTask[]): { done: number; total: number; pct: number } => {
  const items = atomicTasks.filter((atomic) => atomic.taskId === task.id && !atomic.archivedAt);
  const total = items.length;
  const done = items.filter((atomic) => atomic.status === "done").length;
  const pct = total === 0 ? 0 : Math.round((done / total) * 100);
  return { done, total, pct };
};

export const calculateClarity = (title: string, description?: string): number => {
  const words = title.trim().split(/\s+/).filter(Boolean).length;
  const detail = (description?.trim().length ?? 0) / 300;
  const score = Math.min(1, words / 10 + detail * 0.4);
  return Number(score.toFixed(2));
};

export const needsClarification = (task: Task): boolean => {
  if (task.status !== "blocked") return false;
  if (task.blockerKind) return task.blockerKind === "clarity";
  if (task.clarityScore <= 0.75) return true;
  return /clarif|clarity|needs input|decision/i.test(task.blockedReason ?? "");
};

export const parseTaskDetails = (description?: string): ParsedTaskDetails => {
  if (!description || description.trim().length === 0) return {};
  const lines = description
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  const summaryLines: string[] = [];
  let definitionOfDone: string | undefined;
  for (const line of lines) {
    const normalized = line.toLowerCase();
    if (normalized.startsWith("definition of done:")) {
      const value = line.slice("definition of done:".length).trim();
      if (value.length > 0) definitionOfDone = value;
      continue;
    }
    if (normalized.startsWith("attachments:")) continue;
    summaryLines.push(line);
  }

  const summary = summaryLines.join("\n");
  return {
    summary: summary.length > 0 ? summary : undefined,
    definitionOfDone
  };
};
